import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=24072b6b&scoped=true&"
import script from "./NotificationTable.vue?vue&type=script&lang=js&"
export * from "./NotificationTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=24072b6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24072b6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VIcon,VRow})
